/**
 * Authentication utility functions
 * Used as guards in Vuex actions to prevent unnecessary API calls
 */

/**
 * Checks if user has a valid (non-expired) JWT token
 * Used as a guard before making authenticated API calls
 * @returns {boolean} True if user has a valid JWT token
 */
export const isAuthenticated = (): boolean => {
  if (typeof window === "undefined") return false;

  const token = localStorage.getItem("jwt");
  if (!token) return false;

  try {
    // Decode JWT payload (format: header.payload.signature)
    const payload = JSON.parse(atob(token.split(".")[1]));

    // Check expiration
    if (payload.exp) {
      const isExpired = payload.exp < Math.floor(Date.now() / 1000);
      if (isExpired) {
        // Clean up expired session
        localStorage.removeItem("jwt");
        localStorage.removeItem("session");
        return false;
      }
    }

    return true;
  } catch {
    // Invalid token format
    localStorage.removeItem("jwt");
    localStorage.removeItem("session");
    return false;
  }
};
